import React from "react";
import './Confirmation.css'
import '../../../css/material-icons.css'

class Confirmation extends React.Component {
    
    componentDidMount(){
        this.props.onChangeCart();
    }
    render() {
        return (
            <div className="confirmation">
                <h1>Your Order Has Been Confirmed</h1>
                <h2>{"Order ID : "+this.props.location.state.order} </h2>
                {this.props.location.state.receipt?(<h2>{"Receipt No : "+this.props.location.state.receipt} </h2>):('')}
                {this.props.location.state.payLater?(<p>Our sales team will contact you within 48 hours to arrange payment and delivery.</p>):('')}
            </div>

        );
    }
}
export default Confirmation;

